/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcp_Meta_TitleInputs */

const en_mcp_meta_title = /** @type {(inputs: Mcp_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listening MCP for Claude, ChatGPT and AI agents`)
};

const es_mcp_meta_title = /** @type {(inputs: Mcp_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listening MCP para Claude, ChatGPT y agentes de IA`)
};

/**
* | output |
* | --- |
* | "Listening MCP for Claude, ChatGPT and AI agents" |
*
* @param {Mcp_Meta_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mcp_meta_title = /** @type {((inputs?: Mcp_Meta_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Meta_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mcp_meta_title(inputs)
	return en_mcp_meta_title(inputs)
});